const productBundleEntity = {
  external_reference_key: "",
  title: "",
  subtitle: "",
  original_title: "",
  summary: "",
  description: "",
};
export default productBundleEntity;
